export const validators = {
  PASSWORD:
    /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[_@$^*)%(!./#&+-]){1,}).{8,}$/,
}

export const INVOICE_DATE_FORMAT: string = 'dd LLL yyyy'
